import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

interface QuotingNavigationHeaderProps {
  selectedTab: string;
}

export function QuotingNavigationHeader(props: QuotingNavigationHeaderProps) {
  const { selectedTab } = props;

  const breadcrumbDisplayText = selectedTab === 'quoteReview' ? 'Quote Review' : 'Quote Request Form';

  return (
    <Box style={{ display: 'flex', justifyContent: 'space-between', flexFlow: 'row' }}>
      <Breadcrumbs separator='>'>
        <Link underline='hover' color='inherit' component={RouterLink} to='/quoting'>
          Quoting
        </Link>
        <Typography color='text.primary'>{breadcrumbDisplayText}</Typography>
      </Breadcrumbs>
    </Box>
  );
}
